import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Persona from 'persona'
import config from '@/config'
import useProfile from '@/hooks/use-profile'
import { handleEvents, languageMap } from './utils'
import { getPersonaSession } from './api'

const {
  PERSONA_PROD_ENVIRONMENT_ID,
  PERSONA_SANDBOX_ENVIRONMENT_ID,
  PERSONA_TEMPLATE_ID_ID_VERIFICATION
} = config

type VerificationProps = {
  onComplete?: () => void
  onExit?: () => void
}

export const usePersonaIdVerification = () => {
  const profile = useProfile()
  const dispatch = useDispatch()
  const { i18n } = useTranslation()
  const language = i18n.languages[0] || 'en'
  const isProd = config.BUILD_ENV === 'prod'
  const environmentId = isProd ? PERSONA_PROD_ENVIRONMENT_ID : PERSONA_SANDBOX_ENVIRONMENT_ID

  return async ({ onComplete, onExit }: VerificationProps) => {
    let inquiryId = null

    const { response, body }: any = await getPersonaSession()
    if (response?.ok) {
      inquiryId = body?.inquiry_id || null
    } else {
      return
    }

    const templateId = inquiryId ? undefined : PERSONA_TEMPLATE_ID_ID_VERIFICATION
    const referenceId = inquiryId ? undefined : profile?.id

    const client = new Persona.Client({
      templateId,
      referenceId,
      inquiryId,
      environmentId,
      language: languageMap[language],
      fields: {
        name_first: profile?.first_name || '',
        name_last: profile?.last_name || ''
      },
      onLoad: () => {
        client.open()
      },
      onComplete: async () => {
        await dispatch.session.setIdVerificationState('pending')
        onComplete?.()
        // ensure profile is synced with latest BE values after verification
        setTimeout(() => {
          dispatch.profile.loadProfile()
        }, 1000)
      },
      onEvent: (name, meta) => {
        if (name === 'exit') {
          onExit?.()
        }
        handleEvents(name, meta, PERSONA_TEMPLATE_ID_ID_VERIFICATION)
      }
    })
  }
}
